// Testimonios de prueba (estilo capturas de WhatsApp). Se usan como contenido
// de respaldo cuando la tabla `testimonials` está vacía o sin conexión, para que
// el carrusel de la tienda nunca aparezca en blanco. El admin puede editarlos,
// agregar fotos/videos reales o eliminarlos.

export const DEFAULT_TESTIMONIALS = [
  {
    mediaType: 'image',
    mediaUrl:
      'https://readdy.ai/api/search-image?query=Smartphone%20screen%20mockup%20displaying%20a%20friendly%20WhatsApp%20style%20chat%20conversation%20with%20green%20and%20white%20message%20bubbles%20and%20a%20small%20heart%20icon%2C%20soft%20blurred%20contact%20avatar%20at%20the%20top%2C%20clean%20minimal%20flat%20vector%20illustration%20on%20a%20warm%20cream%20neutral%20background%2C%20editorial%20ecommerce%20style%2C%20warm%20muted%20tones%2C%20soft%20shadows&width=900&height=1200&seq=testimonios-manada-01&orientation=portrait',
    caption: 'Amé mis babuchas, son súper cómodas y el diseño es divino. Gracias por tanto.',
    clientName: 'Carolina M. - Bogotá',
    productName: 'Golden Retriever',
    productSlug: 'golden-retriever',
    reply: '¡Bienvenida a la manada! Gracias por confiar en Paticas con Propósito.',
    displayOrder: 1,
    isActive: true,
  },
  {
    mediaType: 'image',
    mediaUrl:
      'https://readdy.ai/api/search-image?query=Close%20up%20of%20a%20hand%20holding%20a%20smartphone%20showing%20a%20cheerful%20customer%20chat%20thread%20with%20green%20chat%20bubbles%20and%20a%20small%20dog%20paw%20emoji%2C%20cozy%20warm%20living%20room%20softly%20blurred%20in%20the%20background%2C%20clean%20flat%20vector%20illustration%2C%20soft%20natural%20lighting%2C%20muted%20terracotta%20and%20cream%20palette%2C%20editorial%20style&width=900&height=1200&seq=testimonios-manada-02&orientation=portrait',
    caption: 'Me llegaron rapidísimo y la calidad es excelente. Ya quiero otro par.',
    clientName: 'Andrés G. - Medellín',
    productName: 'Pantuflas Perro',
    productSlug: 'pantuflas-perro',
    reply: '¡Bienvenido a la manada, Andrés! Nos alegra un montón.',
    displayOrder: 2,
    isActive: true,
  },
  {
    mediaType: 'image',
    mediaUrl:
      'https://readdy.ai/api/search-image?query=Smartphone%20screen%20with%20a%20thank%20you%20message%20chat%2C%20five%20star%20rating%20badge%20and%20a%20tiny%20heart%2C%20floating%20slightly%20above%20a%20plain%20warm%20cream%20background%2C%20minimal%20flat%20vector%20illustration%2C%20soft%20drop%20shadows%2C%20consistent%20warm%20neutral%20editorial%20ecommerce%20style&width=900&height=1200&seq=testimonios-manada-03&orientation=portrait',
    caption: 'Qué belleza, mi familia quedó encantada y el envío llegó perfecto.',
    clientName: 'Paula R. - Cali',
    productName: 'Sencillo Perro',
    productSlug: 'sencillo-perro',
    reply: '¡Bienvenida a la manada, Paula! Gracias por apoyar esta causa.',
    displayOrder: 3,
    isActive: true,
  },
  {
    mediaType: 'image',
    mediaUrl:
      'https://readdy.ai/api/search-image?query=Two%20overlapping%20smartphone%20screens%20showing%20instant%20message%20chat%20bubbles%20and%20a%20cute%20smiling%20dog%20sticker%2C%20clean%20minimal%20flat%20vector%20illustration%20on%20a%20light%20warm%20background%2C%20soft%20shadows%2C%20consistent%20editorial%20ecommerce%20style%2C%20warm%20muted%20palette&width=900&height=1200&seq=testimonios-manada-04&orientation=portrait',
    caption: 'Gracias por el detalle, las paticas son un éxito. Volveré a comprar.',
    clientName: 'Sebastián T. - Barranquilla',
    productName: 'Husky Siberiano',
    productSlug: 'husky-siberiano',
    reply: '¡Bienvenido a la manada! Cada compra ayuda a más animalitos.',
    displayOrder: 4,
    isActive: true,
  },
  {
    mediaType: 'image',
    mediaUrl:
      'https://readdy.ai/api/search-image?query=Single%20smartphone%20mockup%20showing%20a%20happy%20customer%20testimonial%20chat%20with%20cream%20and%20green%20bubbles%20and%20a%20small%20paw%20print%20icon%2C%20minimal%20flat%20vector%20illustration%20centered%20on%20a%20warm%20beige%20background%2C%20soft%20shadows%2C%20clean%20editorial%20ecommerce%20style&width=900&height=1200&seq=testimonios-manada-05&orientation=portrait',
    caption: 'Increíble servicio, súper atentos y el producto es tal cual la foto.',
    clientName: 'Daniela V. - Bucaramanga',
    productName: 'Gato Atigrado',
    productSlug: 'gato-atigrado',
    reply: '¡Bienvenida a la manada! Gracias por tu confianza.',
    displayOrder: 5,
    isActive: true,
  },
];